"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSUpgradeComponent = void 0;
const core_1 = require("@angular/core");
const upgrade_service_1 = require("../services/upgrade.service");
const generic_content_service_1 = require("../services/generic.content.service");
const account_service_1 = require("../services/account.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const _ = require("underscore");
const addline_service_1 = require("../services/addline.service");
const finalize_1 = require("rxjs/internal/operators/finalize");
const token_service_1 = require("../services/token.service");
const generic_content_service_2 = require("../services/generic-content.service");
const common_1 = require("@angular/common");
class CSUpgradeComponent {
    // eslint-disable-next-line max-len
    constructor(genericContentServiceV2, upgradeService, accountService, modalService, genericContentService, addLineService, tokenService, currencyPipe) {
        this.genericContentServiceV2 = genericContentServiceV2;
        this.upgradeService = upgradeService;
        this.accountService = accountService;
        this.modalService = modalService;
        this.genericContentService = genericContentService;
        this.addLineService = addLineService;
        this.tokenService = tokenService;
        this.currencyPipe = currencyPipe;
    }
    ngOnInit() {
        // this.upgradeLine();
        this.disableAddLine = false;
        this.getAccountDetailsInfo();
        this.getPendigDeactivations();
        this.getSubscriptionDetails();
        this.isUpgrade = false;
        this.has12MonthsFreePromo = false;
    }
    ngOnChanges() {
        this.getAccountDetailsInfo();
        this.getPendigDeactivations();
        this.getSubscriptionDetails();
        this.contractType = null;
    }
    upgradeLine(details) {
        if (details) {
            if (!this.isBusiness && !this.isPrepaid) {
                this.getGenericEUPTradeInErrMsgContent();
                this.loading = true;
                this.upgradeService.getEUPTradeInEligibility(details).subscribe((result) => {
                    if (result.success) {
                        this.continueUpgradeLine(details);
                    }
                    else {
                        this.genericEUPTradeInError = result.errorMessage;
                        this.open(this.eupTradeInError);
                    }
                    this.loading = false;
                });
            }
            else {
                this.continueUpgradeLine(details);
            }
        }
    }
    getInstallmentDetail(ContractType, details) {
        this.accountService.getInstallmentDetail(details)
            .subscribe((agreementInfo) => {
            this.installmentDetail = agreementInfo;
            this.has12MonthsFreePromo = agreementInfo.has12MonthsFreePromo;
            this.singleSubObj = _.where(this.subscrptionInfo, { 'subscriptionId': details });
            if (this.installmentDetail !== null) {
                const currentDate = new Date;
                if (this.installmentDetail.upgradeEligibilityDate > currentDate.getTime() && !this.installmentDetail.eupDetails) {
                    this.showToolTipContent('genericContentCannotUpgrade30Days');
                }
                else if (this.installmentDetail.eupDetails && !this.installmentDetail.eupDetails.isEUPUpgradeEligible) {
                    this.showEUPTooltip();
                }
                else {
                    this.upgradeAllowed(ContractType, details);
                }
            }
            else {
                this.upgradeAllowed(ContractType, details);
            }
        }, (err) => {
            // TODO: after implementation of login LOB
            // if (err.status === 401 || err.status === 403) {
            // this.navigateService.onNavigate('/my_account/personal/');
            //  }
        });
    }
    showEUPTooltip() {
        this.loading = true;
        this.genericContentService.getGenericContent('genericErrorMsgEupUpgrade').subscribe((data) => {
            this.loading = false;
            const message = data.contentText;
            const d = new Date(this.installmentDetail.eupDetails.upgradeEligibilityDate);
            const msg = message
                .replace('{upgradeEligibilityDate}', d.toLocaleDateString('en-US'))
                .replace('{eUPEligibleAmount}', this.currencyPipe.transform((this.installmentDetail.eupDetails.eUPEligibleAmount || 0), 'USD'));
            this.messageText = { 'contentText': msg };
            this.tooltip.open(this.tooltip);
        }, (err) => { });
    }
    upgradeAllowed(ContractType, details) {
        if (ContractType === undefined || ContractType === null) {
            this.getContractType(details);
            ContractType = this.contractType;
        }
        this.checkUpgradeLine(ContractType, details);
    }
    open(content, options = { size: 'lg' }) {
        this.modelRef = this.modalService.open(content, options);
    }
    onBlurHide() {
        this.tooltip.close();
    }
    close() {
        this.tooltip.close();
    }
    showToolTipContent(contentId) {
        this.loading = true;
        this.genericContentService.getGenericContent(contentId).subscribe((data) => {
            this.messageText = data;
            this.loading = false;
            this.tooltip.open(this.tooltip);
        }, (err) => {
            // this.error = err;
            this.loading = false;
        });
    }
    getContractType(subscriptionId) {
        this.selectedDevice = _.where(this.subscriptions, { subscriptionId });
        this.subscriptionDetail = this.selectedDevice[0];
        if (this.subscriptionDetail !== undefined && this.subscriptionDetail.hasOwnProperty('contractDetail')) {
            this.selectedContractType = this.subscriptionDetail.contractDetail.contractType;
            this.contractType = this.selectedContractType;
            if (this.selectedContractType === 'DPP') {
                this.dppInstallmentBalance = this.subscriptionDetail.contractDetail.dppDetails.installmentBalance;
            }
        }
        else {
            if (this.subscriptionDetail.restrictedUpgrade) {
                this.isRestrictedUpgrade = this.subscriptionDetail.restrictedUpgrade;
            }
        }
    }
    getSubscriptionDetails() {
        this.accountService.getDeviceListlInformation().subscribe((res) => {
            this.subscriptions = res.deviceDetailList;
        }, (err) => {
            // TODO: after implementation of login LOB
            // if (err.status === 401 || err.status === 403) {
            //     this.navigateService.onNavigate('/my_account/personal/');
            // }
        });
    }
    checkUpgradeLine(ContractType, details) {
        if (ContractType === 'POC') {
            this.closeModal();
            this.open(this.pocContent);
            if (details.hasOwnProperty('subscriptionId')) {
                this.viewDeviceReplacementFee(details.subscriptionId);
            }
            else {
                this.viewDeviceReplacementFee(details);
            }
        }
        else if (ContractType === 'DPP' && !(this.installmentDetail.eupDetails && this.installmentDetail.eupDetails.isEUPUpgradeEligible)) {
            this.showUpgradePopup(details);
        }
        else {
            if (!this.isBusiness) {
                if (this.offerUrl) {
                    const url = this.offerUrl + '?subscriptionId=' + this.subscriptionDetail.subscriptionId + '&userAction=mmaUpgradePhone';
                    window.location.href = url;
                }
                else {
                    if (details.hasOwnProperty('subscriptionId')) {
                        window.location.href = '/buy/devices/?subscriptionId=' + details.subscriptionId + '&userAction=mmaUpgradePhone';
                    }
                    else {
                        window.location.href = '/buy/devices/?subscriptionId=' + details + '&userAction=mmaUpgradePhone';
                    }
                }
            }
            else {
                // business account cart page
                this.upgradeBBDevice();
            }
            this.closeModal();
        }
    }
    viewDeviceReplacementFee(subId) {
        this.loading = true;
        this.upgradeService.getDeviceReplacementFee(subId).pipe(finalize_1.finalize(() => this.genericContentService.getGenericContent('/generic/instructional/ReplacementFeeText').subscribe((res) => {
            this.replacementFeeText = res.contentText;
            this.loading = false;
        }, (err) => {
            this.loading = false;
            this.modelError = err;
        })))
            .subscribe((res) => {
            this.replacementFeeDetail = res.deviceReplacementTierList;
            this.tierId = res.tierId;
        }, (err) => {
            this.loading = false;
            this.modelError = err;
        });
    }
    showDppUpgradeContent(installmentBalance, subId) {
        this.loading = true;
        this.genericContentService.getGenericContent('genericContentUpgradeIneligible').subscribe((data) => {
            this.dppUpgradeContent = data.contentText;
            this.closeModal();
            this.open(this.dppContent);
            this.getCreditAmount(this.dppUpgradeContent, subId);
        }, (err) => {
            this.loading = false;
            this.modelError = err;
        });
    }
    showUpgradeWithoutFeatureInfoContent(subId) {
        if (this.isCPP) {
            this.dppUpgradeContent = '';
            this.closeModal();
            this.open(this.dppContent);
            this.getCreditAmount(this.dppUpgradeContent, subId);
        }
        else {
            this.openWithoutToolTipContent(subId);
        }
    }
    showRapidUpgradeWithFeatureInfoContent(subId) {
        const gc = 'genericContentRapidUpgradeWithFeatureInfo';
        this.openToolTipWithContent(gc, this.subscriptionDetail.contractDetail.dppDetails.noOfInstallments - this.subscriptionDetail.contractDetail.dppDetails.installmentPaid, subId);
    }
    showBOGORapidUpgradeWithFeatureInfoContent(subId) {
        const content = 'genericContentBOGORapidUpgradeWithFeatureInfo';
        this.openToolTipWithContent(content, this.subscriptionDetail.contractDetail.dppDetails.noOfInstallments - this.subscriptionDetail.contractDetail.dppDetails.installmentPaid, subId);
    }
    showRapidUpgradeIneligibleContent(subId) {
        this.openToolTipWithContent('genericContentRapidUpgradeIneligible', this.installmentDetail.remainingChargeAmount, subId);
    }
    showBOGORapidUpgradeIneligibleContent(subId) {
        this.openToolTipWithContent('genericContentBOGORapidUpgradeIneligible', this.installmentDetail.remainingChargeAmount, subId);
    }
    openToolTipWithContent(content, replaceWith, sub) {
        this.loading = true;
        this.genericContentService.getGenericContent(content).subscribe((data) => {
            this.dppUpgradeContent = data.contentText;
            // eslint-disable-next-line max-len
            this.dppUpgradeContent = this.dppUpgradeContent.toString().replace('XXXXX', replaceWith);
            this.closeModal();
            this.open(this.dppContent);
            this.getCreditAmount(this.dppUpgradeContent, sub);
        }, (err) => {
            this.loading = false;
            this.modelError = err;
        });
    }
    openWithoutToolTipContent(sub) {
        this.closeModal();
        this.dppUpgradeContent = '<p> </p>';
        this.open(this.dppContent);
        this.getCreditAmount(this.dppUpgradeContent, sub);
    }
    plainContent(subId) {
        this.loading = true;
        this.dppUpgradeContent = '<p>You can upgrade your current device.</p>';
        this.closeModal();
        this.open(this.dppContent);
        this.getCreditAmount(this.dppUpgradeContent, subId);
    }
    getCreditAmount(content, subId) {
        this.loading = true;
        this.upgradeService.getTradeInCredit(subId)
            .subscribe((data) => {
            let creditBalance;
            if (data != null && data.tradeInCredit != null) {
                creditBalance = data.tradeInCredit;
            }
            else {
                creditBalance = 0;
            }
            // this.dppUpgradeContent = content.replace(new RegExp(('YYYYY'), creditBalance.toFixed(2)));
            this.dppUpgradeContent = content.toString().replace(/YYYYY/g, creditBalance.toFixed(2));
            this.loading = false;
        }, (err) => {
            this.loading = false;
            this.modelError = err;
        });
    }
    navigate() {
        window.location.href = '/buy/devices';
    }
    getAccountDetailsInfo() {
        this.accountService.getAccountDetails().subscribe((res) => {
            this.isPrepaid = res.advancePayAccount;
            this.isBusiness = res.businessAccount;
            this.isStateAccount = res.stateAccount;
            this.pastDue = res.pastDueBalance;
            this.isPastDue = res.pastDue;
            if (res.accountType === 'EMPLOYEE') {
                this.isUpgrade = true;
            }
        });
    }
    upgradePostpaidLine(details) {
        if (this.contractType === undefined || this.contractType === null) {
            if (details.hasOwnProperty('subscriptionId')) {
                this.getContractType(details.subscriptionId);
            }
            else {
                this.getContractType(details);
            }
        }
        if (this.contractType === 'DPP' || this.isRestrictedUpgrade) {
            if (details.hasOwnProperty('subscriptionId')) {
                this.getInstallmentDetail(this.contractType, details.subscriptionId);
            }
            else {
                this.getInstallmentDetail(this.contractType, details);
            }
        }
        else if ((!this.isRestrictedUpgrade) && (this.contractType === undefined || this.contractType === null)) {
            this.checkUpgradeLine(this.contractType, details);
        }
        else {
            this.upgradeAllowed(this.contractType, details);
        }
    }
    getPendigDeactivations() {
        this.accountService.getAccountDetails().subscribe((res) => {
            var _a, _b;
            this.subscrptionInfo = res.subscription;
            this.pendingSubInfo = _.where(this.subscrptionInfo, { 'subscriptionId': this.subscriptionDetail });
            if (((_a = this.pendingSubInfo[0]) === null || _a === void 0 ? void 0 : _a.hasPendingDownload) || ((_b = this.pendingSubInfo[0]) === null || _b === void 0 ? void 0 : _b.esimProfileStatus) === 'Deleted') {
                this.downloadESIM = true;
            }
            else {
                this.downloadESIM = false;
            }
            if (this.pendingSubInfo[0] !== undefined && this.pendingSubInfo[0].pendingDeactivation === true) {
                this.pedingDeact = true;
            }
            else {
                this.pedingDeact = false;
            }
        });
    }
    getDPPBoGoContent() {
        this.loading = true;
        this.genericContentService.getGenericContent('genericInstructionalBogoUpgradeWarning').subscribe((data) => {
            this.bogoGenericContent = data.contentText;
            this.closeModal();
            this.open(this.dppBOGOContent);
            this.loading = false;
        }, (err) => {
            this.loading = false;
            this.modelError = err;
        });
    }
    showBOGOUpgardeDetails(installmentBalance, details) {
        this.showUpgradePopup(details);
    }
    showESNTooltipContent() {
        // this.loading = true;
        this.tooltip.open(this.tooltip);
        // this.genericContentService.getGenericContent(contentId).subscribe((data: any) => {
        //     this.messageText = data;
        //     this.loading = false;
        // }, (err: any) => {
        //     // this.error = err;
        //     this.loading = false;
        // });
    }
    showUpgradePopup(details) {
        if (this.installmentDetail !== null) {
            if (this.installmentDetail.dpp12FeatureExisting) {
                if (!this.installmentDetail.isUpgradeable) {
                    if (this.installmentDetail.upgradeEligibilityAmount - this.installmentDetail.cumulativeChargeAmount > 0) {
                        if (details.hasOwnProperty('subscriptionId') && this.installmentDetail.installmentPromotions.discountType !== 'DPP_BOGO') {
                            this.showRapidUpgradeIneligibleContent(details.subscriptionId);
                        }
                        else if (details.hasOwnProperty('subscriptionId') && this.installmentDetail.installmentPromotions.discountType === 'DPP_BOGO') {
                            this.showBOGORapidUpgradeIneligibleContent(details.subscriptionId);
                        }
                        else {
                            this.showRapidUpgradeIneligibleContent(details);
                        }
                    }
                    else {
                        if (details.hasOwnProperty('subscriptionId')) {
                            this.plainContent(details.subscriptionId);
                        }
                        else {
                            this.plainContent(details);
                        }
                    }
                }
                else {
                    if (details.hasOwnProperty('subscriptionId') && this.installmentDetail.installmentPromotions.discountType !== 'DPP_BOGO') {
                        this.showRapidUpgradeWithFeatureInfoContent(details.subscriptionId);
                    }
                    else if ((details.hasOwnProperty('subscriptionId') && this.installmentDetail.installmentPromotions.discountType === 'DPP_BOGO')) {
                        this.showBOGORapidUpgradeWithFeatureInfoContent(details.subscriptionId);
                    }
                    else {
                        this.showRapidUpgradeWithFeatureInfoContent(details);
                    }
                }
            }
            else {
                if (!this.installmentDetail.upgradeEligible) {
                    if (this.installmentDetail.upgradeEligibilityAmount - this.installmentDetail.cumulativeChargeAmount > 0) {
                        if (details.hasOwnProperty('subscriptionId')) {
                            this.showDppUpgradeContent(this.dppInstallmentBalance, details.subscriptionId);
                        }
                        else {
                            this.showDppUpgradeContent(this.dppInstallmentBalance, details);
                        }
                    }
                    else {
                        if (details.hasOwnProperty('subscriptionId')) {
                            this.plainContent(details.subscriptionId);
                        }
                        else {
                            this.plainContent(details);
                        }
                    }
                }
                else {
                    if (details.hasOwnProperty('subscriptionId')) {
                        this.showUpgradeWithoutFeatureInfoContent(details.subscriptionId);
                    }
                    else {
                        this.showUpgradeWithoutFeatureInfoContent(details);
                    }
                }
            }
        }
        else {
            this.showToolTipContent('genericContentInstallmentPlanDtlSrvcFailed');
        }
    }
    upgradeBBDevice(details) {
        this.loading = true;
        if (this.isBusiness) {
            this.checkItemInCart(details);
        }
    }
    getCPPBalance(isWireless) {
        this.loading = true;
        this.accountService.getCPPBalance(isWireless, true).subscribe((res) => {
            if (res) {
                this.isCPP = res.planDetails.remainingAmount > 0;
                if (this.isCPP) {
                    this.getBlockDPPForCPPInformation();
                }
            }
        }, (err) => {
            this.loading = false;
        });
    }
    getBlockDPPForCPPInformation() {
        this.genericContentService.getGenericContent('genericContentBlockDPPForCPPAccount').subscribe((data) => {
            this.cppInformation = data.contentText;
        }, (err) => {
            this.modelError = err;
        });
    }
    checkItemInCart(details) {
        this.loading = true;
        this.addLineService.getAddLineBusinessEligibility()
            .subscribe((res) => {
            this.loading = false;
            if (res != null && res.cartHasItem !== undefined) {
                this.errorEmptyCart();
                this.iscartHasItem = res.cartHasItem;
                if (this.iscartHasItem) {
                    this.closeModal();
                    this.open(this.clearCart);
                }
            }
            else {
                if (details.hasOwnProperty('subscriptionId')) {
                    this.subId = details.subscriptionId;
                }
                else {
                    this.subId = details;
                }
                this.upgradeService.deviceUpgrade(this.subId)
                    .subscribe((data) => {
                    this.loading = false;
                    location.href = data.successUrl;
                }, (err) => {
                    this.loading = false;
                    this.modelError = err;
                });
            }
        }, (err) => {
            this.loading = false;
            this.modelError = err;
        });
    }
    errorEmptyCart() {
        this.loading = true;
        this.genericContentService.getGenericContent('genericErrorEmptyCart').subscribe((data) => {
            this.cartErrorMsg = data.contentText;
            this.loading = false;
        }, (err) => {
            this.modelError = err;
            this.loading = false;
        });
    }
    getClearCartPopUp() {
        this.closeModal();
        this.open(this.clearCart);
    }
    cartClear() {
        this.loading = true;
        this.addLineService.clearCart()
            .subscribe((data) => {
            this.iscartHasItem = false;
            this.loading = false;
        }, (err) => {
            this.loading = false;
            this.modelError = err;
        });
    }
    promoRedirect(subDetail) {
        if (subDetail && this.offerUrl) {
            if (this.offerUrl) {
                const url = this.offerUrl + '?subscriptionId=' + subDetail.subscriptionId + '&userAction=mmaUpgradePhone';
                window.location.href = url;
            }
            else {
                const url = this.offerUrl;
                window.location.href = url;
            }
        }
        else {
            window.location.href = '/buy/devices/?subscriptionId=' + subDetail.subscriptionId + '&userAction=mmaUpgradePhone';
        }
    }
    closeModal() {
        if (this.activeModal) {
            this.activeModal.close();
        }
    }
    pendingDownload(subscriptionId) {
        var _a;
        const subId = subscriptionId;
        this.manufacturerInfo = _.where(this.subscrptionInfo, { 'subscriptionId': subId });
        const str = (_a = this.manufacturerInfo[0]) === null || _a === void 0 ? void 0 : _a.device.deviceName.toLowerCase();
        this.manufacturerInfo[0].device.deviceName = str.charAt(0).toUpperCase() + str.slice(1);
        this.loading = true;
        this.accountService.getCheckEsimPendingDownload(subscriptionId).subscribe((response) => {
            var _a, _b;
            this.loading = false;
            if (response.hasPendingDownload && (response.activationType === null || response.activationType === undefined || response.activationType === '')) {
                this.loading = true;
                this.genericContentService.getGenericContent('genericErrorMsgActivationTypeMissing').subscribe((data) => {
                    this.loading = false;
                    this.genericErrorMsgActivationTypeMissing = data.contentText;
                }, (err) => {
                    this.loading = false;
                    this.modelError = err;
                });
            }
            else {
                if (this.esimProfileStatus === 'Deleted') {
                    this.loading = true;
                    this.accountService.getESimBypassStatus().subscribe((res) => {
                        var _a, _b;
                        this.loading = false;
                        if ((response === null || response.dailyDiscoveryAttemptsExceeded) === false) {
                            const activationValidation = (res.gsmaBypass && res.alsBypass) || (res.alsBypass && ((_a = this.manufacturerInfo[0]) === null || _a === void 0 ? void 0 : _a.device.deviceName) === 'Apple')
                                || (res.gsmaBypass && ((_b = this.manufacturerInfo[0]) === null || _b === void 0 ? void 0 : _b.device.deviceName) !== 'Apple') ? 'QR_CODE'
                                : 'DISCOVERY';
                            const activationType = (res === null || res === void 0 ? void 0 : res.discoveryBypass) ? 'QR_CODE' : activationValidation;
                            this.loading = true;
                            this.accountService.addESimCard(subscriptionId, activationType).subscribe((esimResp) => {
                                this.accountService.getCheckEsimPendingDownload(subscriptionId).subscribe((checkPendingResponse) => {
                                    var _a, _b, _c;
                                    this.loading = false;
                                    if (checkPendingResponse.hasPendingDownload && checkPendingResponse.activationType) {
                                        if (checkPendingResponse.activationType === 'QR_CODE') {
                                            window.location.href = '/buy/activate/status?subscriptionId=' + subscriptionId + '&attempts=false'
                                                + '&successType=false&allowB2B=true&activationType=' + checkPendingResponse.activationType
                                                + '&manufacturer=' + ((_a = this.manufacturerInfo[0]) === null || _a === void 0 ? void 0 : _a.device.deviceName);
                                        }
                                        else {
                                            window.location.href = '/buy/activate/line?subscriptionId=' + subscriptionId + '&allowB2B=true'
                                                + '&businessAccount=' + this.isBusiness + '&manufacturer=' + ((_b = this.manufacturerInfo[0]) === null || _b === void 0 ? void 0 : _b.device.deviceName);
                                        }
                                    }
                                    else {
                                        window.location.href = '/buy/activate/status?subscriptionId=' + subscriptionId + '&attempts=true'
                                            + '&successType=false&allowB2B=true&manufacturer=' + ((_c = this.manufacturerInfo[0]) === null || _c === void 0 ? void 0 : _c.device.deviceName);
                                    }
                                }, (err) => {
                                    var _a;
                                    this.loading = false;
                                    window.location.href = '/buy/activate/status?subscriptionId=' + subscriptionId + '&attempts=true'
                                        + '&successType=false&allowB2B=true&manufacturer=' + ((_a = this.manufacturerInfo[0]) === null || _a === void 0 ? void 0 : _a.device.deviceName);
                                });
                            }, (err) => {
                                var _a;
                                this.loading = false;
                                window.location.href = '/buy/activate/status?subscriptionId=' + subscriptionId + '&attempts=true'
                                    + '&successType=false&allowB2B=true&manufacturer=' + ((_a = this.manufacturerInfo[0]) === null || _a === void 0 ? void 0 : _a.device.deviceName);
                            });
                        }
                    }, (err) => {
                        var _a;
                        this.loading = false;
                        window.location.href = '/buy/activate/status?subscriptionId=' + subscriptionId + '&attempts=true'
                            + '&successType=false&allowB2B=true&manufacturer=' + ((_a = this.manufacturerInfo[0]) === null || _a === void 0 ? void 0 : _a.device.deviceName);
                    });
                }
                else {
                    if ((response === null || response === void 0 ? void 0 : response.activationType) === 'DISCOVERY') {
                        window.location.href = '/buy/activate/line?subscriptionId=' + subscriptionId + '&allowB2B=true&businessAccount=' + this.isBusiness
                            + '&manufacturer=' + ((_a = this.manufacturerInfo[0]) === null || _a === void 0 ? void 0 : _a.device.deviceName);
                    }
                    else if ((response === null || response === void 0 ? void 0 : response.activationType) === 'QR_CODE') {
                        window.location.href = '/buy/activate/status?subscriptionId=' + subscriptionId + '&attempts=false&successType=false&allowB2B=true&activationType=' +
                            response.activationType + '&manufacturer=' + ((_b = this.manufacturerInfo[0]) === null || _b === void 0 ? void 0 : _b.device.deviceName);
                    }
                }
            }
        }, (err) => {
            this.loading = false;
            this.modelError = err;
        });
    }
    continueUpgradeLine(details) {
        if (details && !this.isPrepaid) {
            this.getCPPBalance(true);
            this.isRestrictedUpgrade = false;
            if (!this.isBusiness) {
                if (!this.selectedDevice) {
                    this.selectedDevice = _.where(this.subscriptions, { 'subscriptionId': details });
                }
                if (this.selectedDevice !== undefined) {
                    this.subscriptionDetail = this.selectedDevice[0];
                    if (this.subscriptionDetail !== undefined && this.subscriptionDetail.promotionApplied === true) {
                        this.getDPPBoGoContent();
                    }
                    else {
                        this.upgradePostpaidLine(details);
                    }
                }
                else {
                    this.upgradePostpaidLine(details);
                }
            }
            else {
                this.upgradeBBDevice(details);
            }
        }
        else {
            this.upgradeAllowed(this.contractType, details);
        }
    }
    getGenericEUPTradeInErrMsgContent() {
        this.genericContentServiceV2.getGenericContent('genericEUPTradeInNotEligibleErrMsg').subscribe((data) => {
            this.genericEUPTradeInError = data.contentText;
        }, (err) => { });
    }
    getSimLockStatus(subscriptionDetail) {
        if (this.isSimLockEnabled === undefined) {
            this.loading = true;
            this.accountService.getSimChangeAndPortOutLockStatus().subscribe((simLockStatusResponse) => {
                this.loading = false;
                this.isSimLockEnabled = simLockStatusResponse.simLock;
                if (simLockStatusResponse.simLock) {
                    this.showToolTipContent('genericSimChangeLockWarning');
                }
                else {
                    this.upgradeLine(subscriptionDetail);
                }
            }, (err) => {
                this.loading = false;
                this.modelError = err;
                this.upgradeLine(subscriptionDetail);
            });
        }
        else {
            if (this.isSimLockEnabled) {
                this.showToolTipContent('genericSimChangeLockWarning');
            }
            else {
                this.upgradeLine(subscriptionDetail);
            }
        }
    }
}
exports.CSUpgradeComponent = CSUpgradeComponent;
//# sourceMappingURL=upgrade.component.js.map